import type * as React from 'react';

import { cn } from '../../lib/utils';

export interface DashboardLayoutProps {
  sidebar: React.ReactNode;
  header: React.ReactNode;
  /**
   * Optional filter row rendered between the header and the scrollable content.
   * Stays fixed — does not scroll with the widget grid.
   */
  filters?: React.ReactNode;
  children: React.ReactNode;
  /** Current sidebar width (open or collapsed) in pixels. The app derives this from its store. */
  sidebarWidth: number;
  className?: string;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  sidebar,
  header,
  filters,
  children,
  sidebarWidth,
  className,
}) => {
  return (
    <div
      className={cn(
        'w-full h-screen bg-dawn-cream relative overflow-hidden transition-colors duration-200',
        className
      )}
    >
      {sidebar}

      <div
        className="absolute top-0 right-0 h-full flex flex-col gap-5 p-5"
        style={{
          width: `calc(100% - ${sidebarWidth}px)`,
          transition: 'width 200ms ease-in-out',
        }}
      >
        {header}
        {filters && <div className="shrink-0">{filters}</div>}
        <div className="flex-1 min-h-0 overflow-auto">{children}</div>
      </div>
    </div>
  );
};

DashboardLayout.displayName = 'DashboardLayout';
